import Spinner from "~/common/components/Spinner/Spinner";
import ModalContainer from "~/common/components/ModalContainer";
import type * as React from "react";
import { useSelector } from "react-redux";
import { type RootState } from "~/app/store";
import { useTranslation } from "react-i18next";

const FullscreenLoader: React.FC = () => {
  const msg = useSelector(selectLoaderMsg);
  const { t } = useTranslation();
  return (
    <ModalContainer>
      <div className="scha__fullscreen-loader">
        <Spinner label={t(msg)} />
      </div>
    </ModalContainer>
  );
};

const selectLoaderMsg = (state: RootState) => state.cartPage.requestInFlightMessage;

export default FullscreenLoader;
